"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TFoot = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var row_1 = require("./row");
function TFoot(_a) {
    var footerGroups = _a.footerGroups, props = __rest(_a, ["footerGroups"]);
    if (footerGroups.length === 0) {
        return null;
    }
    return (react_1.default.createElement(StyledTFoot, __assign({}, props), footerGroups.map(function (footerGroup) { return (react_1.default.createElement(row_1.Row, __assign({}, footerGroup.getFooterGroupProps()), footerGroup.headers.map(function (column) { return (react_1.default.createElement(StyledTD, __assign({ className: tdClassName }, column.getFooterProps()), column.render('Footer'))); }))); })));
}
exports.TFoot = TFoot;
var tdClassName = 'newfront-spreadsheet--tfoot-tr';
var StyledTFoot = styled_components_1.default.div((_a = {
        position: 'sticky',
        bottom: 0,
        zIndex: 1
    },
    _a["& .".concat(row_1.trClassName, ":first-child .").concat(tdClassName, ":first-child")] = {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        borderRight: "1px solid ".concat(core_ui_1.colors.border.default),
    },
    _a));
var StyledTD = styled_components_1.default.div({
    height: 48,
    boxSizing: 'border-box',
    padding: '12px 8px',
    textAlign: 'left',
    fontWeight: 600,
    borderTop: "1px solid ".concat(core_ui_1.colors.border.default),
    borderBottom: "1px solid ".concat(core_ui_1.colors.border.default),
    color: core_ui_1.colors.steel[400],
    backgroundColor: '#fff',
    marginBottom: 1,
});
